/**
 * マニフェスト管理
 * マニフェスト検索キーワード
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_manifest_search_keyword = {
  namespaced: true,
  actions: {
    /**
     * 編集データの取得
     * @param commit
     * @param manifest_id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { manifest_id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${manifest_id}/manifest_search_keyword/edit`).then(data => {
          resolve(data.content);
        })
      })
    },
    /**
     * 更新
     * @param commit
     * @param manifest_id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { manifest_id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(`${API_PATH}/${manifest_id}/manifest_search_keyword`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true });
          resolve(content);
        } )
      })
    },
  },
}
export default manifest_management_manifest_search_keyword;
